import { render } from "./NotarialTransactionList.vue?vue&type=template&id=bfe418ca&scoped=true"
import script from "./NotarialTransactionList.vue?vue&type=script&lang=js"
export * from "./NotarialTransactionList.vue?vue&type=script&lang=js"

import "./NotarialTransactionList.vue?vue&type=style&index=0&id=bfe418ca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe418ca"]])

export default __exports__